import { createSelector } from "reselect";
import { AppsStateOrganization, NodeType, OrganizationNode } from ".";
import { AppStateLogin } from "../auth";
import { IAppState } from "../types";
import { AppStateUserProfile } from "../userProfile";
import { authReady } from "../userProfile/selectors";
import { RoleType } from "../users";
import { TFunction } from "i18next";

export const organizationNodes = (state: IAppState): OrganizationNode[] =>
  state.organization.nodes;
export const currentUserBaseNode = (state: IAppState): number =>
  state.userProfile.baseNodeId;
export const userSelectedNodeId = (state: IAppState): number =>
  state.userProfile.selectedNodeId;
export const userSelectedENDNodeId = (state: IAppState): number =>
  state.userProfile.endNodeId;
// export const userSelectedReportNodeId = (state: IAppState): number => state.userProfile.endNodeId;
export const userMonitorNodeId = (state: IAppState): number =>
  state.userProfile.monitorNodeId;

export const pushNotificationNodes = createSelector(
  userMonitorNodeId,
  organizationNodes,
  (userMonitorNodeId, organizationNodes) => {
    console.log(userMonitorNodeId);
    if (userMonitorNodeId === undefined) return [];
    const isUnderNode = (userNodeId: number, maybeTop: number) => {
      // if (userNodeId === currentUserBaseNode) //myself
      //     return true;
      const selectedNodePath = pathToNode(organizationNodes, userNodeId, false);
      return selectedNodePath.some((el) => el.id === maybeTop);
    };
    const groupsToListen = (el: OrganizationNode) =>
      el.type === NodeType.Group && isUnderNode(el.id, userMonitorNodeId);
    return childrenToArr(groupsToListen, organizationNodes).map((el) =>
      el.id.toString()
    );
  }
);

export const endNodesAvaliableIds = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    console.log(currentUserBaseNode);
    if (currentUserBaseNode === undefined) return [];
    const isUnderNode = (userNodeId: number, maybeTop: number) => {
      // if (userNodeId === currentUserBaseNode) //myself
      //     return true;
      const selectedNodePath = pathToNode(organizationNodes, userNodeId, true);
      return selectedNodePath.some((el) => el.id === maybeTop);
    };
    const groupsToListen = (el: OrganizationNode) =>
      el.type === NodeType.Group && isUnderNode(el.id, currentUserBaseNode);
    return childrenToArr(groupsToListen, organizationNodes).map((el) => el.id);
  }
);

export const startFromNodeId = createSelector(userMonitorNodeId, (node) => {
  return userMonitorNodeId;
});

export const allBuildings = createSelector(
  organizationNodes,
  (organizationNodes) => {
    const onlyBuildings = (el: OrganizationNode) =>
      el.type === NodeType.Building;
    return childrenToArr(onlyBuildings, organizationNodes);
  }
);

export const rootNode = createSelector(
  organizationNodes,
  (organizationNodes) => {
    return organizationNodes[0]?.id || undefined;
  }
);

export const allDepartments = createSelector(
  organizationNodes,
  (organizationNodes) => {
    const onlyDepartments = (el: OrganizationNode) =>
      el.type === NodeType.Department;
    return childrenToArr(onlyDepartments, organizationNodes);
  }
);

export const allAvaliableBuildings = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const avaliable: Map<string | number, boolean> = childrenToMap(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    );
    const onlyBuildings = (el: OrganizationNode) =>
      el.type === NodeType.Building && avaliable.get(el.id);
    return childrenToArr(onlyBuildings, organizationNodes);
  }
);

export const allAvaliableDepartments = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const avaliable: Map<string | number, boolean> = childrenToMap(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    );
    const onlyDepartments = (el: OrganizationNode) =>
      el.type === NodeType.Department && avaliable.get(el.id);
    console.log("allAvaliableDepartments");
    return childrenToArr(onlyDepartments, organizationNodes);
  }
);

export const allAvaliableGroups = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const avaliable: Map<string | number, boolean> = childrenToMap(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    );
    const onlyGroups = (el: OrganizationNode) =>
      el.type === NodeType.Group && avaliable.get(el.id);

    return childrenToArr(onlyGroups, organizationNodes);
  }
);

export const userAssessNode = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const myNode = childrenToArr(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    )[0];
    return myNode;
  }
);

export const parentOfUserAccessNode = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const myNode = childrenToArr(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    )[0];
    if (!myNode || myNode?.type === NodeType.Root) return undefined;
    const parents = fromTreeTopToCondition(
      organizationNodes[0],
      (el) => el.id === myNode.id
    );
    const parent = parents[parents.length - 2];
    return parent;
  }
);
export const userAssessDefaultENDNode = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (currentUserBaseNode, organizationNodes) => {
    const myNodeAndBottom = childrenToArr(
      (el: OrganizationNode) => el.id === currentUserBaseNode,
      organizationNodes
    );

    const firstEnd = childrenToArr(
      (el: OrganizationNode) =>
        el.nodesTree.length === 0 &&
        (el.type === NodeType.Department || el.type === NodeType.Group),
      myNodeAndBottom
    )[0];
    return firstEnd?.id || undefined;
  }
);

export const isExistAllNodes = createSelector(
  (state: IAppState) => state.userProfile.monitorNodeId,
  (state: IAppState) => state.userProfile.selectedNodeId,
  (state: IAppState) => state.userProfile.endNodeId,
  (state: IAppState) => state.organization.isLoading,
  organizationNodes,
  (monitorNodeId, selectedNodeId, endNodeId, isLoading, organizationNodes) => {
    if (isLoading || isLoading === undefined)
      return { isMonitorNode: true, isSelectedNode: true, isEndNode: true };
    const isMonitor = monitorNodeId
      ? nodeById(organizationNodes, monitorNodeId)
      : false;
    const isSelected = selectedNodeId
      ? nodeById(organizationNodes, selectedNodeId)
      : false;
    const isEndNode = endNodeId
      ? nodeById(organizationNodes, endNodeId)
      : false;
    return {
      isMonitorNode: isMonitor,
      isSelectedNode: isSelected,
      isEndNode: isEndNode,
    };
  }
);

export const isSelectedEndNodeISActualEND = createSelector(
  (state: IAppState) => state.userProfile.endNodeId,
  (state: IAppState) => state.organization.isLoading,
  organizationNodes,
  (endNodeId, isLoading, organizationNodes) => {
    if (isLoading || isLoading === undefined) return true;
    const isEndNode = endNodeId
      ? nodeById(organizationNodes, endNodeId)?.type === NodeType.Group
      : false;
    return isEndNode;
  }
);

export const isContainsBuildings = createSelector(
  organizationNodes,
  (organizationNodes) => {
    return organizationNodes[0] === undefined
      ? false
      : organizationNodes[0].nodesTree.length > 0;
  }
);

/** function searches target node by @condition in @organizationNodes
 * Then if @addBottomChildren - moves down the tree to accumulate target's children
 * if there is no nodes - @onEmpty callback will be called
 * @result - Map(nodeId, true/false), where true means that nodeId was in the way down the tree to target or node is a child of target
 */
export const treeByCondition = (
  condition: (el: OrganizationNode) => boolean,
  organizationNodes: OrganizationNode[],
  addBottomChildren: boolean,
  onEmpty?: () => Map<number, boolean>
): Map<number, boolean> => {
  const nodesVisibility: Map<number, boolean> = new Map();
  const root = organizationNodes[0];
  const allNodes = childrenToArr(() => true, organizationNodes);
  const pathToAllowed: OrganizationNode[] = fromTreeTopToCondition(
    root,
    condition
  ).reverse();
  const conditionNode: OrganizationNode = pathToAllowed[0];
  if (!conditionNode) return onEmpty();
  if (addBottomChildren) {
    const goDownTree = (node: OrganizationNode) => {
      if (node.nodesTree.length) {
        node.nodesTree.forEach((child) => {
          pathToAllowed.push(child);
          goDownTree(child);
        });
      }
    };
    goDownTree(conditionNode);
  }
  allNodes.forEach((node) => {
    if (pathToAllowed.indexOf(node) !== -1) nodesVisibility.set(node.id, true);
    else nodesVisibility.set(node.id, false);
  });

  return nodesVisibility;
};

export const userPermissionsString = createSelector(
  (state: IAppState) => state.organization.nodes,
  (_: IAppState, baseNodeId: string | number) => baseNodeId,
  (organizationNodes: OrganizationNode[], baseNodeId: string | number) => {
    const path = pathToNode(organizationNodes, baseNodeId, false);
    if (path.length === 0) return organizationNodes[0]?.title;
    let pathStr = path.reduce((str, el) => str + el?.title + " > ", "");
    const lastElement = path.pop();
    if (lastElement) {
      if (lastElement.type === NodeType.Group)
        pathStr = pathStr.substring(0, pathStr.length - 3);
      else {
        if (lastElement.nodesTree.length !== 0) {
          if (lastElement.type === NodeType.Department) pathStr += "All Groups";
          if (lastElement.type === NodeType.Building)
            pathStr += "All Departments";
        } else pathStr = pathStr.substring(0, pathStr.length - 3);
      }
    }
    return pathStr;
  }
);

export const userPermissionsStringCreator = () => {
  return createSelector(
    (state: IAppState) => state.organization.nodes,
    (_: IAppState, baseNodeId: string | number) => baseNodeId,
    (organizationNodes: OrganizationNode[], baseNodeId: string | number) => {
      const path = pathToNode(organizationNodes, baseNodeId, false);
      if (path.length === 0) return organizationNodes[0]?.title;
      let pathStr = path.reduce((str, el) => str + el?.title + " > ", "");
      const lastElement = path.pop();
      if (lastElement) {
        if (lastElement.type === NodeType.Group)
          pathStr = pathStr.substring(0, pathStr.length - 3);
        else {
          if (lastElement.nodesTree.length !== 0) {
            if (lastElement.type === NodeType.Department)
              pathStr += "All Groups";
            if (lastElement.type === NodeType.Building)
              pathStr += "All Departments";
          } else pathStr = pathStr.substring(0, pathStr.length - 3);
        }
      }
      return pathStr;
    }
  );
};

export const pathToNodeSelectorCreator = () => {
  return createSelector(
    organizationNodes,
    (_: IAppState, nodeId: number) => nodeId,
    (_: IAppState, __: number, includeRoot: boolean) => includeRoot,
    (organizationNodes, nodeId, includeRoot) => {
      const path = pathToNode(organizationNodes, nodeId, includeRoot);

      return path;
    }
  );
};

export const userHasAccessToNode = createSelector(
  currentUserBaseNode,
  organizationNodes,
  (_: IAppState, nodeIdToCheck: number) => nodeIdToCheck,
  (currentUserBaseNode, organizationNodes, nodeIdToCheck) => {
    if (!nodeIdToCheck) return false;

    const isUnderNode = (userNodeId: number, maybeTop: number) => {
      const selectedNodePath = pathToNode(organizationNodes, userNodeId, true);
      return selectedNodePath.some((el) => el.id === maybeTop);
    };

    return isUnderNode(nodeIdToCheck, currentUserBaseNode);
  }
);

export const isNodeBelongsToMonirotoredNodeCreator = () => {
  return createSelector(
    userMonitorNodeId,
    organizationNodes,
    (_: IAppState, nodeIdToCheck: number) => nodeIdToCheck,
    (userMonitorNodeId, organizationNodes, nodeIdToCheck) => {
      const parent = nodeById(organizationNodes, userMonitorNodeId);
      return (
        fromTreeTopToCondition(parent, (el) => el?.id === nodeIdToCheck)
          .length > 0
      );
    }
  );
};

/** **************************************** utils functions **************************************** */
export const pathToNode = (
  organizationNodes: OrganizationNode[],
  baseNodeId: string | number,
  includeRoot: boolean
): OrganizationNode[] => {
  const condition = (el: OrganizationNode) => el?.id === baseNodeId;
  const path: OrganizationNode[] = fromTreeTopToCondition(
    organizationNodes[0],
    condition
  );
  if (!includeRoot) path.shift();
  return path;
};

export const nodeById = (
  organizationNodes: OrganizationNode[],
  findId: number
): OrganizationNode => {
  return childrenToArr(
    (el: OrganizationNode) => el.id === findId,
    organizationNodes
  )[0];
};

export const isNodeBelongsToParent = (
  organizationNodes: OrganizationNode[],
  possibleParent: number,
  possibleChild: number
): boolean => {
  const parent = nodeById(organizationNodes, possibleParent);
  return (
    fromTreeTopToCondition(parent, (el) => el?.id === possibleChild).length > 0
  );
};

export const childrenToArr = (
  condition: (el: OrganizationNode) => boolean,
  tree: OrganizationNode[]
): OrganizationNode[] => {
  const conditionArr: OrganizationNode[] = [];
  const goThrow = (tree: OrganizationNode[]) => {
    tree.forEach((el) => {
      if (condition(el)) conditionArr.push(el);
      if (el.nodesTree.length) goThrow(el.nodesTree);
    });
  };
  goThrow(tree);
  return conditionArr;
};

const childrenToMap = (
  condition: (el: OrganizationNode) => boolean,
  tree: OrganizationNode[]
): Map<number | string, boolean> => {
  const conditionArr: Map<number | string, boolean> = new Map();
  const goThrow = (tree: OrganizationNode[], passBool: boolean = undefined) => {
    tree.forEach((el) => {
      const thisValBool = condition(el) || passBool;
      conditionArr.set(el.id, thisValBool);
      if (el.nodesTree.length) goThrow(el.nodesTree, thisValBool);
    });
  };
  goThrow(tree);
  return conditionArr;
};

export const fromTreeTopToCondition = (
  node: OrganizationNode,
  condition: (el: OrganizationNode) => boolean
): OrganizationNode[] => {
  let pathToAllowed: OrganizationNode[] = [];
  const topToBottom = (
    node: OrganizationNode,
    allowedNodes: OrganizationNode[]
  ) => {
    allowedNodes.push(node);
    if (condition(node)) {
      pathToAllowed = allowedNodes.concat();
    }
    if (node?.nodesTree.length)
      node?.nodesTree.forEach((element) => {
        topToBottom(element, allowedNodes);
      });
    allowedNodes.pop();
  };
  topToBottom(node, []);
  return pathToAllowed;
};

export const organizationReady = createSelector(
  (state: IAppState): AppStateLogin => state.auth,
  (state: IAppState): AppStateUserProfile => state.userProfile,
  (state: IAppState): AppsStateOrganization => state.organization,
  (auth, userProfile, organization) => {
    return auth.isAuthenticated && organization.isLoading === false;
  }
);

export const organizationNodesReady = createSelector(
  (state: IAppState): AppStateLogin => state.auth,
  (state: IAppState): AppStateUserProfile => state.userProfile,
  (state: IAppState): AppsStateOrganization => state.organization,
  userMonitorNodeId,
  (auth, userProfile, organization, userMonitorNodeId) => {
    // console.log(
    //     'nodes ready ',
    //     auth.isAuthenticated,
    //     userProfile.isLoading === false,
    //     userMonitorNodeId !== undefined,
    //     organization.isLoading === false,
    // );
    return (
      auth.isAuthenticated &&
      userProfile.isLoading === false &&
      (userMonitorNodeId !== undefined ||
        (organization.isLoading === false &&
          organization?.nodes[0].nodesTree?.length === 0)) &&
      organization.isLoading === false
    );
  }
);

export const relatedDepartmentName = createSelector(
  organizationNodes,
  (_: IAppState, nodeTo: number) => nodeTo,
  (organizationNodes, nodeTo) => {
    const path = pathToNode(organizationNodes, nodeTo, true);
    const dep = path.find((el) => el.type === NodeType.Department);
    return dep?.title || "";
  }
);

export const shouldDisplayDepartmentLevelSettings = createSelector(
  userAssessNode,
  authReady,
  (state: IAppState) => state.userProfile.roleName,
  (userNode, mainLoaded, roleName) => {
    if (!mainLoaded) return false;
    if (userNode?.type === NodeType.Group) return false;
    if (
      [RoleType.DISPLAY, RoleType.CAREGIVER, RoleType.API_USER].indexOf(
        roleName
      ) !== -1
    )
      return false;
    return true;
  }
);

export const headerPath = createSelector(
  organizationNodes,

  userMonitorNodeId,
  (_: IAppState, t: TFunction) => t,
  (organizationNodes, nodeTo, t) => {
    const path = pathToNode(organizationNodes, nodeTo, true);
    let pathArr: any[] = path.map((el) => {
      return { type: el?.type, title: el?.title, id: el?.id };
    });
    const lastElement = path.pop();
    if (lastElement && lastElement.nodesTree.length !== 0) {
      if (lastElement.type === NodeType.Department)
        pathArr.push({ type: NodeType.Group, title: t("labels.allGroups") });
      if (lastElement.type === NodeType.Building)
        pathArr.push({
          type: NodeType.Department,
          title: t("labels.allDepart"),
        });
      if (lastElement.type === NodeType.Root)
        pathArr = pathArr.concat([
          { type: NodeType.Building, title: t("labels.allBuild") },
        ]);
    }
    pathArr.shift();
    return pathArr;
  }
);
